import styled from 'styled-components';

export const CloseGridButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2rem 0 1rem 0;
`;
